import { trackStoreeelEvent } from '@/helpers/trackStoreeelEvent';
import { getSwiperInstance } from '@/helpers/swiperInstance'; // ← Swiperインスタンス取得関数

export const trackMediaProcess = () => {
  const swiper = getSwiperInstance(); // Swiperインスタンスを取得
  if (!swiper) return;

  let video = null;
  let observer = null;
  let timeupdateHandler = null;

  const initVideoTracking = (targetVideo) => {
    if (!targetVideo) return;

    targetVideo.setAttribute('data-reached-checkpoints', '[]');

    timeupdateHandler = () => {
      if (!targetVideo.duration) return;
      const currentProgress = (targetVideo.currentTime / targetVideo.duration) * 100;
      const checkpoints = [20, 40, 60, 80, 100];
      const alreadyReached = JSON.parse(targetVideo.getAttribute('data-reached-checkpoints') || '[]');
      const mediaName = targetVideo.getAttribute('media-name') || '';

      checkpoints.forEach((point) => {
        if (currentProgress >= point && !alreadyReached.includes(point)) {
          alreadyReached.push(point);
          trackStoreeelEvent('storeeel_movie_progress', {
            'storeeel_name': mediaName,
            'media_progress': point,
            'media_id': targetVideo.getAttribute('media-id'),
            'campaign_id': window.storeeelItems.id,
          });
        }
      });

      targetVideo.setAttribute('data-reached-checkpoints', JSON.stringify(alreadyReached));
    };

    targetVideo.addEventListener('timeupdate', timeupdateHandler);

    observer = new MutationObserver((mutationsList) => {
      for (const mutation of mutationsList) {
        if (mutation.type === 'attributes' && mutation.attributeName === 'src') {
          targetVideo.setAttribute('data-reached-checkpoints', '[]');
        }
      }
    });

    observer.observe(targetVideo, { attributes: true, attributeFilter: ['src'] });
  };

  const handleSlideChange = () => {
    const newVideo = document.querySelector('.storeeel-swiper-group-wrapper .swiper-slide-active .storeeel-movie');
    if (newVideo && newVideo !== video) {
      if (observer) observer.disconnect();
      if (video && timeupdateHandler) {
        video.removeEventListener('timeupdate', timeupdateHandler);
      }

      video = newVideo;
      initVideoTracking(video);
    }
  };

  swiper.on('slideChangeTransitionEnd', handleSlideChange);

  // 初回実行
  handleSlideChange();
};
